import httpClientRFP from './httpClientRFP';
import { throwApiError } from '../utils';
import { API_ENDPOINTS } from './apiEndpoints';

interface ConsentPayload {
  email: string;
  first_name: string;
  last_name: string;
  company_name: string;
  role_name: string;
}

interface ConsentResponse {
  success: boolean;
  message: string;
  data?: {
    user: {
      id: string;
      email: string;
      first_name: string;
      last_name: string;
      company_name: string;
      role_name: string;
      created_at: string;
    };
  };
}

class RfpAuthService {
  async validateRFPLink(rfpLinkId: string) {
    try {
      const response = await httpClientRFP.get(
        API_ENDPOINTS.rfp.validateRFPLink(rfpLinkId)
      );
      return response.data;
    } catch (error) {
      // Rethrow error to allow component to handle specific status codes (e.g. 410)
      throw error;
    }
  }
  /**
   * Submit consent form and get OTP
   * @param rfpLinkId - The RFP link ID from the RFP URL
   * @param data - Consent form data
   */
  async submitConsent(
    rfpLinkId: string,
    data: ConsentPayload
  ): Promise<ConsentResponse> {
    try {
      const response = await httpClientRFP.post(
        API_ENDPOINTS.rfp.createRFPUser(rfpLinkId),
        data
      );
      return response.data;
    } catch (error) {
      return throwApiError(error, 'Error submitting consent');
    }
  }

  /**
   * Verify OTP and get RFP token
   * @param rfpLinkID - The RFP link ID from the RFP URL
   * @param data - OTP data
   */
  async verifyOTP(rfpLinkID: string, data: { email: string; otp: string }) {
    try {
      const response = await httpClientRFP.post(
        API_ENDPOINTS.rfp.verifyOTP(rfpLinkID),
        data
      );

      if (response.data?.data?.token) {
        sessionStorage.setItem('aloRfpToken', response.data.data.token);
      } else if (response.data?.rfpToken) {
        sessionStorage.setItem('aloRfpToken', response.data.rfpToken);
      } else if (response.data?.token) {
        sessionStorage.setItem('aloRfpToken', response.data.token);
      }

      return response.data;
    } catch (error) {
      // Rethrow the full error to allow component to handle specific status codes (e.g. 410)
      // Don't use throwApiError here as we need access to error.response
      throw error;
    }
  }

  /**
   * Check if RFP token exists in sessionStorage
   */
  hasRfpToken(): boolean {
    return !!sessionStorage.getItem('aloRfpToken');
  }

  /**
   * Clear RFP token from sessionStorage
   */
  clearRfpToken(): void {
    sessionStorage.removeItem('aloRfpToken');
  }

  /**
   * Get RFP token from sessionStorage
   */
  getRfpToken(): string | null {
    return sessionStorage.getItem('aloRfpToken');
  }
}
export const rfpAuthService = new RfpAuthService();
export type { ConsentPayload, ConsentResponse };
